import { put, takeLeading } from 'redux-saga/effects';

import promotionApi from 'api/promotionApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  // GET PROMOTION DETAIL
  GET_PROMOTION_DETAIL,
  GET_PROMOTION_DETAIL_SUCCESS,
  GET_PROMOTION_DETAIL_FAILED,

  // GET PROMOTION LIST
  GET_PROMOTION_LIST,
  GET_PROMOTION_LIST_SUCCESS,
  GET_PROMOTION_LIST_FAILED,

  // CREATE BASIC PROMOTION
  CREATE_PROMOTION,
  CREATE_PROMOTION_SUCCESS,
  CREATE_PROMOTION_FAILED,

  // EDIT BASIC PROMOTION
  EDIT_PROMOTION,
  EDIT_PROMOTION_SUCCESS,
  EDIT_PROMOTION_FAILED,

  // DELETE BASIC PROMOTION
  DELETE_PROMOTION,
  DELETE_PROMOTION_SUCCESS,
  DELETE_PROMOTION_FAILED,
  CREATE_PLACE_PROMOTION_SUCCESS,
  CREATE_PLACE_PROMOTION_FAILED,
  CREATE_PLACE_PROMOTION,
  GET_PLACE_PROMOTION_DETAIL_SUCCESS,
  GET_PLACE_PROMOTION_DETAIL_FAILED,
  GET_PLACE_PROMOTION_DETAIL,
  DELETE_PLACE_PROMOTION_SUCCESS,
  DELETE_PLACE_PROMOTION_FAILED,
  DELETE_PLACE_PROMOTION,
  GET_PLACE_PROMOTION_LIST,
  GET_PLACE_PROMOTION_LIST_SUCCESS,
  GET_PLACE_PROMOTION_LIST_FAILED,
  DELETE_PROMOTION_DISCOUNT_SUCCESS,
  DELETE_PROMOTION_DISCOUNT_FAILED,
  DELETE_PROMOTION_DISCOUNT,
  GET_USABLE_MARKETING_PROMOTION_LIST,
  GET_USABLE_MARKETING_PROMOTION_LIST_SUCCESS,
  GET_USABLE_MARKETING_PROMOTION_LIST_FAILED,
  GET_USABLE_MARKETING_PROMOTION_DETAIL,
  GET_USABLE_MARKETING_PROMOTION_DETAIL_SUCCESS,
  GET_USABLE_MARKETING_PROMOTION_DETAIL_FAILED,
} from './actionTypes';

function* getPromotionDetail({ payload }) {
  try {
    const response = yield promotionApi.getPromotionDetail(payload);

    yield put({
      type: GET_PROMOTION_DETAIL_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_PROMOTION_DETAIL_FAILED,
    });
  }
}

function* getPromotionList({ payload }) {
  try {
    const response = yield promotionApi.getPromotionList(payload);

    yield put({
      type: GET_PROMOTION_LIST_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_PROMOTION_LIST_FAILED,
    });
  }
}

function* getPlacePromotionList({ payload }) {
  try {
    const response = yield promotionApi.getPlacePromotionList(payload);

    yield put({
      type: GET_PLACE_PROMOTION_LIST_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_PLACE_PROMOTION_LIST_FAILED,
    });
  }
}

function* createPromotion({ payload }) {
  const { callback } = payload;
  try {
    yield promotionApi.createPromotion(payload);

    yield put({
      type: CREATE_PROMOTION_SUCCESS,
    });

    callback();

    showSuccess('Tạo ưu đãi thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: CREATE_PROMOTION_FAILED,
    });
  }
}

function* editPromotion({ payload }) {
  const { callback } = payload;
  try {
    yield promotionApi.editPromotion(payload);

    yield put({
      type: EDIT_PROMOTION_SUCCESS,
    });

    callback();

    showSuccess('Chỉnh sửa ưu đãi thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_PROMOTION_FAILED,
    });
  }
}

function* endPromotion({ payload }) {
  const { callback } = payload;
  try {
    yield promotionApi.endPromotion(payload);

    yield put({
      type: DELETE_PROMOTION_SUCCESS,
    });

    callback();

    showSuccess('Ngừng ưu đãi thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_PROMOTION_FAILED,
    });
  }
}

function* createPlacePromotion({ payload }) {
  const { callback, promotion } = payload;
  try {
    yield promotionApi.createPlacePromotion(promotion);

    yield put({
      type: CREATE_PLACE_PROMOTION_SUCCESS,
    });

    callback();

    // if (promotionId) {
    //   showSuccess('Cập nhật ưu đãi thành công');
    // } else {
    //   showSuccess('Tạo ưu đãi thành công');
    // }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: CREATE_PLACE_PROMOTION_FAILED,
    });
  }
}

function* getPlacePromotionDetail({ payload }) {
  try {
    const response = yield promotionApi.getPlacePromotionDetail(payload);

    yield put({
      type: GET_PLACE_PROMOTION_DETAIL_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_PLACE_PROMOTION_DETAIL_FAILED,
    });
  }
}

function* endPlacePromotion({ payload }) {
  const { callback, status } = payload;
  try {
    yield promotionApi.endPlacePromotion(payload);

    yield put({
      type: DELETE_PLACE_PROMOTION_SUCCESS,
    });

    callback();

    if (status === 'PENDING') {
      showSuccess('Xoá ưu đãi thành công');
    } else {
      showSuccess('Ngừng ưu đãi thành công');
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_PLACE_PROMOTION_FAILED,
    });
  }
}

function* deletePromotionDiscount({ payload }) {
  const { callback } = payload;
  try {
    yield promotionApi.deletePromotionDiscount(payload);

    yield put({
      type: DELETE_PROMOTION_DISCOUNT_SUCCESS,
    });

    callback();

    showSuccess('Xoá ưu đãi thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_PROMOTION_DISCOUNT_FAILED,
    });
  }
}

function* getUsableMarketingPromotionList({ payload }) {
  try {
    const response = yield promotionApi.getUsableMarketingPromotionList(payload);

    yield put({
      type: GET_USABLE_MARKETING_PROMOTION_LIST_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_USABLE_MARKETING_PROMOTION_LIST_FAILED,
    });
  }
}

function* getUsableMarketingPromotionDetail({ payload }) {
  try {
    const response = yield promotionApi.getUsableMarketingPromotionDetail(payload);

    yield put({
      type: GET_USABLE_MARKETING_PROMOTION_DETAIL_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_USABLE_MARKETING_PROMOTION_DETAIL_FAILED,
    });
  }
}

export default function* promotionSaga() {
  yield takeLeading(GET_PROMOTION_DETAIL, getPromotionDetail);
  yield takeLeading(GET_PROMOTION_LIST, getPromotionList);
  yield takeLeading(CREATE_PROMOTION, createPromotion);
  yield takeLeading(EDIT_PROMOTION, editPromotion);
  yield takeLeading(DELETE_PROMOTION, endPromotion);
  yield takeLeading(CREATE_PLACE_PROMOTION, createPlacePromotion);
  yield takeLeading(GET_PLACE_PROMOTION_DETAIL, getPlacePromotionDetail);
  yield takeLeading(DELETE_PLACE_PROMOTION, endPlacePromotion);
  yield takeLeading(GET_PLACE_PROMOTION_LIST, getPlacePromotionList);
  yield takeLeading(DELETE_PROMOTION_DISCOUNT, deletePromotionDiscount);
  yield takeLeading(GET_USABLE_MARKETING_PROMOTION_LIST, getUsableMarketingPromotionList);
  yield takeLeading(GET_USABLE_MARKETING_PROMOTION_DETAIL, getUsableMarketingPromotionDetail);
}
